export default {
    "mp_link_element": {
        "msg": {
            "noresults": "Sem resultados",
            "nolayers": "Não existe nenhum tema associado a esta funcionalidade",
            "novisiblelayers": "Necessário ativar pelo menos um dos temas: <b>{names}</b>",
            "validlayers": "Seleccione um elemento dos temas: <b>{names}</b>",
            "confirm_update_link": "Deseja atualizar as ligações?",
            "title_link": "Associar {inventory}?",
            "title_new_link": "Associar novo registo com {inventory}?",
            "confirm_new_link": "Deseja associar ao elemento um novo registo com o Nº de Inventário {inventory}?",
            "confirm_replace_link": "Deseja utilizar o registo para associar o Nº de Inventário {inventory} ao elemento?",
        },
    },
    "data_patrimony": {
        "msg": {
            "title_info_modal": "Nº Inventário: {id}",
        },
    }
}
